import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faqs" aria-labelledby="faqs-title" className="bg-white py-14 text-ink sm:py-20 lg:py-24" data-id="element-159" data-mp="x5mwgkxdwzqv">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-160" data-mp="124g807t42goe">
        <SectionHeading id="faqs-title" tone="light" eyebrow="FAQ" lead="A few quick" highlight="answers" data-id="element-161" data-mp="1ptio3b83k1gs" />

        <ul className="mt-8 space-y-2 sm:mt-10" data-id="element-162" data-mp="1uqr87hct2fko">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const buttonId = `faq-button-${index}`;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.question} className={`border ${isOpen ? 'border-forest' : 'border-[#E5E7EB]'}`} data-id="element-163" data-mp="28qju8zde07mb" data-mpi={index}>
                <h3 data-id="element-164" data-mp="2di1vlojboa7t">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex min-h-[60px] w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6" data-id="element-165" data-mp="2dijyv54ejop8">
                    <span className="text-[17px] font-bold leading-snug" data-id="element-166" data-mp="2tojtwaqg9hiu">{faq.question}</span>
                    <span aria-hidden="true" className={`flex h-9 w-9 shrink-0 items-center justify-center transition-colors duration-150 ${isOpen ? 'bg-forest text-gold' : 'bg-mint text-forest'}`} data-id="element-167" data-mp="37foupg5k0fur">
                      <PlusIcon strokeWidth={2.75} className={`h-5 w-5 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-168" data-mp="3cgcno7dcf6rm" />
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} data-id="element-169" data-mp="27r90px1cs1wn">
                  <p className="px-5 pb-6 text-base leading-relaxed text-[#374151] sm:px-6" data-id="element-170" data-mp="2bskgzbyc7as6">{faq.answer}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}